export default "__VITE_ASSET__DLEhQjHq__"